import { render, staticRenderFns } from "./PODView.vue?vue&type=template&id=03366b24&scoped=true&"
import script from "./PODView.vue?vue&type=script&lang=js&"
export * from "./PODView.vue?vue&type=script&lang=js&"
import style0 from "./PODView.vue?vue&type=style&index=0&id=03366b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03366b24",
  null
  
)

export default component.exports